import React from 'react';
import Navbar from '../../ReusableBlocks/Navbar';
import SupportContent from './SupportContent';

const InternalSupportPage = () => {
  return (
    <div className="authenticated-support-layout">
      <Navbar />
      <main className="internal-support-page">
        <SupportContent variant="internal" />
      </main>
    </div>
  );
};

export default InternalSupportPage;
